import * as React from 'react';
import { RadioContext } from '../Radio';
function renderRadios(children, itemSpacing) {
    return React.Children.toArray(children).map((child, index) => index + 1 !== React.Children.count(children)
        ? React.cloneElement(child, {
            spacingBottom: child.props.spacingBottom ||
                itemSpacing,
        })
        : child);
}
class RadioGroup extends React.Component {
    render() {
        const { children, itemSpacing, className, name, selectedValue, onChange, ...rest } = this.props;
        return (React.createElement("div", { className: className, ...rest },
            React.createElement(RadioContext.Provider, { value: { radioGroup: { name, selectedValue, onChange } } }, renderRadios(children, itemSpacing ?? 'normal'))));
    }
}
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map